import { ChangeDetectorRef, Component, OnInit, SimpleChange, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer } from
  '@angular/common';
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {

  currentUrl: any;

  constructor(private router: Router,
    private _route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platform: Object
  ) { }
  setDocTitle(title: string) {
    // console.log('current title:::::' + this.titleService.getTitle());
    this.titleService.setTitle(title);
  }

  ngOnInit(): void {
    this.currentUrl = '/';
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = this.router.url;
        // console.log("currenturl",this.currentUrl)

        // window.scrollTo(0, 0)
        // console.log("currentUrlshow");
        // Show loading indicator
      }
      if (event instanceof NavigationStart) {
        // Show loading indicator
        // console.log("navigation start")
      }
      if (isPlatformBrowser(this.platform)) {
        window.scrollTo(0, 0);
        // $('.navbar-nav>li>a').on('click', function(){
        //   $('.navbar-collapse').collapse('hide');
        // });
      }


    });



  }

  // ngOnChanges(changes:SimpleChange){
  //   this.currentUrl = this.router.url;
  //   console.log("currenturl-----",this.currentUrl)
  // }

  ngAfterViewInit() {
    this.currentUrl = this.router.url;
    // console.log("currenturl after",this.currentUrl)
    this.cdRef.detectChanges();
  }

}
